(function () {
  if (window.uxSliderInit) return;
  window.uxSliderInit = true;

  const SLIDER = '.ux-slider';
  const BAR = '.ux-slider__bar';
  const THUMB = '.ux-slider__thumb';

  const barFor = (slider) => (slider.parentElement ? slider.parentElement.querySelector(BAR) : null);
  const thumbFor = (bar) => (bar ? bar.querySelector(THUMB) : null);
  const sliderForThumb = (el) => {
    const bar = el.closest(BAR);
    return bar && bar.parentElement ? bar.parentElement.querySelector(SLIDER) : null;
  };

  const sync = (slider) => {
    const ratio = slider.clientWidth / slider.scrollWidth;
    const scrollable = isFinite(ratio) && ratio < 1;
    slider.classList.toggle('is-scrollable', scrollable);
    const bar = barFor(slider);
    if (!bar) return;
    const thumb = thumbFor(bar);
    if (!thumb) return;
    if (!scrollable) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = 'block';
    thumb.style.width = (ratio * 100) + '%';
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const maxThumb = bar.clientWidth - thumb.clientWidth;
    thumb.style.transform = 'translateX(' + (maxScroll ? (slider.scrollLeft / maxScroll) * maxThumb : 0) + 'px)';
  };

  const syncAll = () => document.querySelectorAll(SLIDER).forEach(sync);

  let dragSlider = null, dragStartX = 0, dragStartScroll = 0, didDrag = false;
  let thumbSlider = null, thumbStartX = 0, thumbStartScroll = 0;

  document.addEventListener('pointerdown', (e) => {
    const thumb = e.target.closest(THUMB);
    if (thumb) {
      thumbSlider = sliderForThumb(thumb);
      if (thumbSlider) {
        thumbStartX = e.pageX;
        thumbStartScroll = thumbSlider.scrollLeft;
        e.preventDefault();
      }
      return;
    }
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    const slider = e.target.closest(SLIDER);
    if (!slider || slider.scrollWidth <= slider.clientWidth) return;
    dragSlider = slider;
    dragStartX = e.pageX;
    dragStartScroll = slider.scrollLeft;
    didDrag = false;
  });

  document.addEventListener('pointermove', (e) => {
    if (thumbSlider) {
      const bar = barFor(thumbSlider);
      const thumb = thumbFor(bar);
      const maxThumb = bar.clientWidth - thumb.clientWidth;
      const maxScroll = thumbSlider.scrollWidth - thumbSlider.clientWidth;
      const dx = e.pageX - thumbStartX;
      thumbSlider.scrollLeft = thumbStartScroll + (maxThumb ? (dx / maxThumb) * maxScroll : 0);
      e.preventDefault();
      return;
    }
    if (!dragSlider) return;
    const dx = e.pageX - dragStartX;
    if (!didDrag && Math.abs(dx) > 4) {
      didDrag = true;
      dragSlider.classList.add('is-dragging');
    }
    if (didDrag) {
      dragSlider.scrollLeft = dragStartScroll - dx;
      e.preventDefault();
    }
  });

  document.addEventListener('pointerup', () => {
    if (dragSlider && didDrag) {
      const slider = dragSlider;
      slider.classList.remove('is-dragging');
      const block = (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
      };
      slider.addEventListener('click', block, { capture: true, once: true });
      setTimeout(() => slider.removeEventListener('click', block, true), 80);
    }
    dragSlider = null;
    thumbSlider = null;
  });

  document.addEventListener('scroll', (e) => {
    if (e.target && e.target.matches && e.target.matches(SLIDER)) sync(e.target);
  }, true);

  window.addEventListener('resize', syncAll);
  window.addEventListener('load', syncAll);
  document.addEventListener('shopify:section:load', syncAll);

  if (document.readyState !== 'loading') {
    syncAll();
  } else {
    document.addEventListener('DOMContentLoaded', syncAll);
  }
})();